export default {
  'groupings.list.header.code': 'Purchase Code',
  'groupings.list.header.description': 'Description',
  'groupings.list.header.installments': 'Number of Installments',
  'groupings.list.header.amount': 'Amount',
  'groupings.list.header.actions': 'Action',
  
  
  'groupings.generate.clusters': 'Generate Clusters',
  'groupings.generate.searchAccounts': 'Search Accounts',


  'groupings.form.company': 'Company',
  'groupings.form.debtor': 'Debtor',
  'groupings.form.customer': 'Customer',
  'groupings.form.insurer': 'Insurer',
  };